import axios from "axios";

import { PaymentSessionToken } from "redmond";
import { FulfillResponse, purchaseApi } from "@b2bportal/purchase-api";

export const pollFinalizedV1 = ({
  req,
}: {
  req: PaymentSessionToken;
}): Promise<FulfillResponse> =>
  new Promise((resolve, reject) => {
    try {
      const res = purchaseApi(axios).apiV1PurchaseFulfillPollPut({
        value: req.value,
      });

      res.then((body) => resolve(body.data)).catch((e) => reject(e));
    } catch (e) {
      reject(e);
    }
  });
